import React from "react";
import { Phone, MapPin, Bike, Hash } from "lucide-react";
import { cardCls, labelCls } from "./tokens";

/**
 * CustomerSummaryCard — compact identity panel.
 * Variants: complete (all fields) | minimal (name + phone only)
 */
export default function CustomerSummaryCard({
  name,
  mobile,
  vehicle,
  srNumber,
  location,
  testId,
}) {
  const initials = (name || "—")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div
      data-testid={
        testId || `customer-summary-${(srNumber || name || "x").toLowerCase().replace(/\s+/g, "-")}`
      }
      className={`${cardCls} p-6 flex flex-col gap-4`}
    >
      <div className="flex items-start gap-4">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-od-input bg-onedesk-primary text-white font-bold text-base shrink-0">
          {initials}
        </span>
        <div className="flex flex-col gap-1 min-w-0 flex-1">
          <span className={labelCls}>Customer</span>
          <h4 className="font-bold text-lg text-onedesk-textPrimary truncate">
            {name || "—"}
          </h4>
          {mobile && (
            <span className="inline-flex items-center gap-1.5 font-medium text-sm text-onedesk-textSecondary">
              <Phone className="h-3.5 w-3.5" strokeWidth={2.25} />
              {mobile}
            </span>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 border-t border-onedesk-border pt-4">
        <Field label="SR Number" Icon={Hash} value={srNumber} />
        <Field label="Vehicle" Icon={Bike} value={vehicle} />
        <Field label="Location" Icon={MapPin} value={location} />
      </div>
    </div>
  );
}

function Field({ label, value, Icon }) {
  return (
    <div className="flex flex-col gap-1">
      <span className={labelCls}>{label}</span>
      <span className="inline-flex items-center gap-1.5 font-bold text-sm text-onedesk-textPrimary">
        {Icon && <Icon className="h-3.5 w-3.5 text-onedesk-textSecondary" strokeWidth={2.25} />}
        {value || "—"}
      </span>
    </div>
  );
}
